import stringsToSymbols from "@/util/strings-to-symbols.mjs";

export type WeaponCategory = {
  key: string;
  t: Translation;
};

export const WEAPON_CATEGORIES_SYMBOLS = stringsToSymbols([
  "fortniteAllWeapons",
  "melee",
  "pistols",
  "shotguns",
  "smgs",
  "assault-rifles",
  "marksman-rifles",
  "snipers",
  "bows",
  "crossbows",
  "explosives",
  "light-machine-guns",
  "masks",
  "sprites",
]);

export const WEAPON_CATEGORIES: Record<symbol, WeaponCategory> = {
  [WEAPON_CATEGORIES_SYMBOLS.fortniteAllWeapons]: {
    key: "all",
    t: ["fortnite:weaponCategories.all", "All Weapons"] as Translation,
  },
  [WEAPON_CATEGORIES_SYMBOLS.melee]: {
    key: "melee",
    t: ["fortnite:weaponCategories.melee", "Melee"] as Translation,
  },
  [WEAPON_CATEGORIES_SYMBOLS.pistols]: {
    key: "pistols",
    t: ["fortnite:weaponCategories.pistols", "Pistols"] as Translation,
  },
  [WEAPON_CATEGORIES_SYMBOLS.shotguns]: {
    key: "shotguns",
    t: ["fortnite:weaponCategories.shotguns", "Shotguns"] as Translation,
  },
  [WEAPON_CATEGORIES_SYMBOLS.smgs]: {
    key: "smgs",
    t: ["fortnite:weaponCategories.smgs", "SMGs"] as Translation,
  },
  [WEAPON_CATEGORIES_SYMBOLS["assault-rifles"]]: {
    key: "assault-rifles",
    t: [
      "fortnite:weaponCategories.assaultRifles",
      "Assault Rifles",
    ] as Translation,
  },
  [WEAPON_CATEGORIES_SYMBOLS["marksman-rifles"]]: {
    key: "marksman-rifles",
    t: [
      "fortnite:weaponCategories.marksmanRifles",
      "Marksman Rifles",
    ] as Translation,
  },
  [WEAPON_CATEGORIES_SYMBOLS["snipers"]]: {
    key: "snipers",
    t: ["fortnite:weaponCategories.snipers", "Snipers"] as Translation,
  },
  [WEAPON_CATEGORIES_SYMBOLS.bows]: {
    key: "bows",
    t: ["fortnite:weaponCategories.bows", "Bows"] as Translation,
  },
  [WEAPON_CATEGORIES_SYMBOLS.crossbows]: {
    key: "crossbows",
    t: ["fortnite:weaponCategories.crossbows", "Crossbows"] as Translation,
  },
  [WEAPON_CATEGORIES_SYMBOLS["light-machine-guns"]]: {
    key: "light-machine-guns",
    t: [
      "fortnite:weaponCategories.lightMachineGuns",
      "Light Machine Guns",
    ] as Translation,
  },
  [WEAPON_CATEGORIES_SYMBOLS.explosives]: {
    key: "explosives",
    t: ["fortnite:weaponCategories.explosives", "Explosives"] as Translation,
  },
  [WEAPON_CATEGORIES_SYMBOLS.masks]: {
    key: "masks",
    t: ["fortnite:weaponCategories.masks", "Masks"] as Translation,
  },
  [WEAPON_CATEGORIES_SYMBOLS.sprites]: {
    key: "sprites",
    t: ["fortnite:weaponCategories.sprites", "Sprites"] as Translation,
  },
};

export const categories = Object.getOwnPropertySymbols(WEAPON_CATEGORIES)
  .filter((symbol) => symbol !== WEAPON_CATEGORIES_SYMBOLS.fortniteAllWeapons)
  .map((s) => WEAPON_CATEGORIES[s]);
